import * as Sentry from '@sentry/vue'

const dsn = import.meta.env.VITE_SENTRY_DSN as string
const environment = import.meta.env.VITE_SENTRY_ENV as string
const regexTarget = /^\//

export default function (app: any, router: any) {
  if (dsn && !(environment.includes('localhost'))) {
    Sentry.init({
      app,
      debug: import.meta.env.DEV,
      dsn,
      environment,
      release: __APP_VERSION__,
      integrations: [
        Sentry.browserTracingIntegration(({ router })),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        'localhost',
        '*.pg.com',
        '*.phoenix-graphics.com',
        regexTarget,
      ],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    })
  }
}
